import { Fragment } from 'react';

export default function Steps (props) {
  return (
    <div
      id="wp-block-gds-lead-form__steps"
      className={"wp-block-gds-lead-form__steps"}
    >
      {props.hidden ? (
        null
      ) : props.done ? (
        <div className="active wp-block-gds-lead-form__steps-item">✓</div>
      ) : props.steps ? (
        <>
          {[...new Array(props.steps).fill()].map((_, i) =>
            <Fragment key={i}>
              <div className={`${i+1 <= props.active ? 'active' : ''} wp-block-gds-lead-form__steps-item`}>{i+1}</div>
              {i+1 < props.steps && (<div className={"wp-block-gds-lead-form__steps-separator"}></div>)}
            </Fragment>
          )}
        </>
      ) : (
        <div className="active wp-block-gds-lead-form__steps-item">{props.active}</div>
      )}
    </div>
  );
}
